export default "__VITE_ASSET__BQeJzctm__"